// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/gateway.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/gateway.proto.
 */
export const file_gitpod_v1_gateway: GenFile = /*@__PURE__*/
  fileDesc("ChdnaXRwb2QvdjEvZ2F0ZXdheS5wcm90bxIJZ2l0cG9kLnYxIkcKE0xpc3RHYXRld2F5c1JlcXVlc3QSMAoKcGFnaW5hdGlvbhgBIAEoCzIcLmdpdHBvZC52MS5QYWdpbmF0aW9uUmVxdWVzdCJ3ChRMaXN0R2F0ZXdheXNSZXNwb25zZRIsCghnYXRld2F5cxgBIAMoCzISLmdpdHBvZC52MS5HYXRld2F5Qga6SAPIAQESMQoKcGFnaW5hdGlvbhgCIAEoCzIdLmdpdHBvZC52MS5QYWdpbmF0aW9uUmVzcG9uc2UiRAoHR2F0ZXdheRIUCgRuYW1lGAEgASgJQga6SAPIAQESEwoDdXJsGAIgASgJQga6SAPIAQESDgoGcmVnaW9uGAMgASgJMoABCg5HYXRld2F5U2VydmljZRJeCgxMaXN0R2F0ZXdheXMSHi5naXRwb2QudjEuTGlzdEdhdGV3YXlzUmVxdWVzdBofLmdpdHBvZC52MS5MaXN0R2F0ZXdheXNSZXNwb25zZSINkAIBsqseBhIEbGlzdBoOqqseCgoIZ2F0ZXdheXNCLFoqZ2l0aHViLmNvbS9naXRwb2QtaW8vZ2l0cG9kLW5leHQvYXBpL2dvL3YxYgZwcm90bzM", [file_buf_validate_validate, file_gitpod_tools_v1_stainless, file_gitpod_v1_pagination]);

/**
 * @generated from message gitpod.v1.ListGatewaysRequest
 */
export type ListGatewaysRequest = Message<"gitpod.v1.ListGatewaysRequest"> & {
  /**
   * pagination contains the pagination options for listing gateways
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListGatewaysRequest.
 * Use `create(ListGatewaysRequestSchema)` to create a new message.
 */
export const ListGatewaysRequestSchema: GenMessage<ListGatewaysRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_gateway, 0);

/**
 * @generated from message gitpod.v1.ListGatewaysResponse
 */
export type ListGatewaysResponse = Message<"gitpod.v1.ListGatewaysResponse"> & {
  /**
   * gateways contains the list of gateways
   *
   * @generated from field: repeated gitpod.v1.Gateway gateways = 1;
   */
  gateways: Gateway[];

  /**
   * pagination contains the pagination response
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;
};

/**
 * Describes the message gitpod.v1.ListGatewaysResponse.
 * Use `create(ListGatewaysResponseSchema)` to create a new message.
 */
export const ListGatewaysResponseSchema: GenMessage<ListGatewaysResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_gateway, 1);

/**
 * Gateway represents a system gateway that provides access to services
 *
 * @generated from message gitpod.v1.Gateway
 */
export type Gateway = Message<"gitpod.v1.Gateway"> & {
  /**
   * name is the human-readable name of the gateway. name is unique across all gateways.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * url of the gateway
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * region is the geographical region where the gateway is located
   *
   * @generated from field: string region = 3;
   */
  region: string;
};

/**
 * Describes the message gitpod.v1.Gateway.
 * Use `create(GatewaySchema)` to create a new message.
 */
export const GatewaySchema: GenMessage<Gateway> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_gateway, 2);

/**
 * @generated from service gitpod.v1.GatewayService
 */
export const GatewayService: GenService<{
  /**
   * @generated from rpc gitpod.v1.GatewayService.ListGateways
   */
  listGateways: {
    methodKind: "unary";
    input: typeof ListGatewaysRequestSchema;
    output: typeof ListGatewaysResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_gateway, 0);

